import { useState, useContext, useEffect } from "react";
import axios from "axios";
import AuthContext from "../context/AuthContext";
import GLOBALVAR from "../constants";
import logo from "../logo.svg";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useContext(AuthContext);

    useEffect(() => {
        document.body.style.background = `url('/background-login.jpg') no-repeat center center fixed`;
        document.body.style.backgroundSize = "cover";

        return () => {
            document.body.style.background = ""; // Cleanup when component unmounts
        };
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Start loading
        try {
            const { data } = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/users/login`, { email, password });
            login(data.token, data.user);
        } catch (error) {
            alert("Invalid credentials");
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="login-container card shadow-lg p-4 bg-white" style={{ width: '25rem' }}>
                <div className="text-center mb-4">
                    <a href="/">
                        <img src={logo} alt="logo" />
                    </a>
                </div>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            disabled={isLoading} // Disable input when loading
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                            disabled={isLoading} // Disable input when loading
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span> Logging in...
                            </>
                        ) : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
